<template>
  <div class="pt-mask" @click.self="close">
    <div class="pt-modal">
      <div class="pt-head">
        <h4>추천 조직도<span v-if="admin"> (관리자)</span></h4>
        <div class="pt-head-right">
          <span class="pt-legend"><i class="dot inactive"></i>Non-active / 통산매출0(흰색)</span>
          <button class="pt-x" @click="close">닫기</button>
        </div>
      </div>

      <!-- 스펙27/207: 네모 칸 색상표(직급별). 검색 조건 바로 위에 표시 -->
      <div class="pt-colorbar">
        <span class="pt-colorbar-title">직급 색상표</span>
        <span v-for="r in rankColorList" :key="r.name" class="pt-color-item">
          <i class="sw" :style="r.grad
              ? { background: 'linear-gradient(90deg,#0A4DA4 50%,#DE2F2C 50%)' }
              : { background: '#' + r.hex }"></i>{{ displayRank(r.name) }}
        </span>
      </div>

      <!-- 20007 검색조건 배치도: 센터(에디트 비활성/검색/비우기) · 이름(에디트 비활성/검색/비우기) · 라디오 · 확대축소 · 시점 · 월 · 조회 -->
      <div class="pt-toolbar">
        <label>센터</label>
        <input class="cond" type="text" :value="centerName" placeholder="" disabled />
        <button class="primary" @click="centerOpen = true">검색</button>
        <button class="ghost" @click="clearCenter">비우기</button>
        <label>이름</label>
        <!-- 조직도 팝업창 내 이름 조회 입력받기 프로젝트 -->
         <input class="cond cond-edit" type="text" v-model="custName" placeholder="" @input="custLoginId = ''" @keyup.enter="doSearch" />
        <button class="primary" @click="searchOpen = true">검색</button>
        <button class="ghost" @click="clearMember">비우기</button>

        <span class="pt-radios">
          <label class="rd"><input type="radio" value="L" v-model="side" /> 나의 좌측</label>
          <label class="rd"><input type="radio" value="R" v-model="side" /> 나의 우측</label>
          <label class="rd"><input type="radio" value="B" v-model="side" /> 나의 좌/우측</label>
        </span>

        <span class="pt-sep"></span>
        <span class="pt-zoom-label">확대/축소</span>
        <button class="pt-zoom" @click="zoomOut" :disabled="zoom <= 0.1" title="축소">−</button>
        <span class="pt-zoom-val">{{ Math.round(zoom * 100) }}%</span>
        <button class="pt-zoom" @click="zoomIn" :disabled="zoom >= 1" title="확대">+</button>

        <!-- 3008: 확대/축소 우측 "시점" 콤보(이력 스냅샷). admin 전용(staff/customer 미표시=항상 현재/라이브).
             배치일마다 수당계산직전(BEFORE)/직후(AFTER), 마지막은 "현재"(라이브 GRE_NODE). 진입 기본=최신 수당계산직후. -->
        <template v-if="isAdminUser">
          <span class="pt-sep"></span>
          <span class="pt-zoom-label">시점</span>
          <select class="pt-snapsel" v-model="selectedPoint" title="조회 시점 선택">
            <option v-for="opt in snapOptions" :key="opt.value" :value="opt.value">{{ opt.label }}</option>
          </select>
          <!-- 3008: 조회 버튼과 콤보 사이 "월" 선택기. 콤보는 이 달의 수당계산직전/직후만 표시(+현재). -->
          <span class="pt-zoom-label">월</span>
          <input type="month" class="pt-basedate" v-model="selectedMonth" :max="curMonth" title="조회 월 선택" />
        </template>

        <button class="primary" @click="doSearch">조회</button>

        <span class="pt-summary-inline" v-if="!loading && !error && layoutNodes.length">
          기준 <b>{{ rootLabel }}</b> · 네모를 클릭하면 다음 대가 펼쳐집니다
        </span>
      </div>

      <div class="pt-body">
        <div v-if="loading" class="pt-msg">불러오는 중...</div>
        <div v-else-if="error" class="pt-msg err">{{ error }}</div>
        <div v-else-if="!layoutNodes.length" class="pt-msg">이름을 입력하거나 검색 버튼으로 회원을 선택한 뒤 [조회]를 누르세요.</div>

        <div v-else class="pt-canvas">
          <svg :width="svgW * zoom" :height="svgH * zoom" :viewBox="'0 0 ' + svgW + ' ' + svgH">
            <defs>
              <linearGradient id="rtGradDia" x1="0" y1="0" x2="1" y2="0">
                <stop offset="0%" stop-color="#0A4DA4" /><stop offset="50%" stop-color="#0A4DA4" />
                <stop offset="50%" stop-color="#DE2F2C" /><stop offset="100%" stop-color="#DE2F2C" />
              </linearGradient>
            </defs>
            <polygon :points="roofPoints" class="pt-roof" />
            <rect :x="frameX" :y="frameY" :width="frameW" :height="frameH" rx="6" class="pt-frame" />

            <g v-for="b in floorBands" :key="'band-' + b.key">
              <rect :x="frameX" :y="b.y" :width="frameW" :height="floorH"
                    :class="['pt-band', b.idx % 2 === 0 ? 'even' : 'odd']" />
              <line :x1="frameX" :y1="b.y" :x2="frameX + frameW" :y2="b.y" class="pt-floor-line" />
              <text v-if="b.label" :x="frameX - 8" :y="b.y + floorH / 2 + 4" text-anchor="end" class="pt-floor-label">
                {{ b.label }}
              </text>
            </g>

            <path v-for="(e, i) in layoutEdges" :key="'edge-' + i" :d="e.d" class="pt-edge" />

            <!-- 스펙209: 적색 기준선 삭제(좌=L, 우=R 배치는 그대로 유지) -->

            <g v-for="n in layoutNodes" :key="n.key"
               :transform="'translate(' + n.x + ',' + n.y + ')'"
               :class="{ 'clickable': n.clickable }" @click="onNodeClick(n)">
              <rect :width="nodeW" :height="nodeH" rx="6" class="pt-node"
                    :fill="nodeFill(n)" :stroke="n.selected ? '#ff8c00' : nodeStroke(n)"
                    :stroke-width="n.selected ? 2.4 : 1.4" />
              <text :x="nodeW / 2" :y="15" text-anchor="middle"
                    :fill="nodeText(n)" class="pt-node-name">{{ n.name }}</text>
              <text :x="nodeW / 2" :y="28" text-anchor="middle"
                    :fill="nodeText(n)" class="pt-node-sub">{{ n.loginId }}</text>
              <text :x="nodeW / 2" :y="39" text-anchor="middle"
                    :fill="nodeText(n)" class="pt-node-rank">{{ displayRank(n.rankName) }}</text>
              <!-- 스펙24003: 직급 아래 가입일/첫구매일/최근재구매일. 상하여백 11px, 폰트 9.5px.
                   첫구매가 없으면 첫구매일 줄, 재구매가 없으면 최근재구매일 줄 미표시(공간은 유지). -->
              <text :x="nodeW / 2" :y="50" text-anchor="middle"
                    :fill="nodeText(n)" class="pt-node-join">가입일: {{ n.joinDt }}</text>
              <text v-if="n.firstBuyDt" :x="nodeW / 2" :y="61" text-anchor="middle"
                    :fill="nodeText(n)" class="pt-node-join">첫 구매일: {{ n.firstBuyDt }}</text>
              <text v-if="n.lastRepurchaseDt" :x="nodeW / 2" :y="72" text-anchor="middle"
                    :fill="nodeText(n)" class="pt-node-join">최근 재구매일: {{ n.lastRepurchaseDt }}</text>
              <!-- 스펙214: 관리자 화면 - 날짜줄 아래 금액 표시. 1 row=추천매칭 캐시백, 그 외=팀캐시백×0.05.
                   표시 조건: 해당 row 번호 <= A 의 추천매칭 정산 대수. "5%" 글자 미표시 -->
              <text v-if="admin && n.showAdmin && shownAmounts" :x="nodeW / 2" :y="85" text-anchor="middle"
                    :fill="nodeText(n)" class="pt-node-cb5">{{ n.adminPrefix }}{{ fmt(n.adminAmount) }}</text>
              <text v-if="n.leg" :x="5" :y="12" :fill="nodeText(n)" class="pt-leg-badge">{{ n.leg }}</text>
            </g>
          </svg>
        </div>
      </div>
    </div>

    <!-- 20007: 이름 항목 검색 = 회원 검색 팝업, 센터 항목 검색 = 센터 검색 팝업 -->
    <SettlementMemberSearchDialog v-if="searchOpen" :self-children-only="true" @select="onUserSelect" @close="searchOpen = false" />
    <SettlementCenterSearchDialog v-if="centerOpen" @select="onCenterSelect" @close="centerOpen = false" />
  </div>
</template>


<script>
import api from '../api';
import { canViewAll, isAdmin } from '../store/auth';
import SettlementMemberSearchDialog from './SettlementMemberSearchDialog.vue';
import SettlementCenterSearchDialog from './SettlementCenterSearchDialog.vue';

const MAX_GEN = 100000;   // 스펙217: 종단 제한 없음(네모는 계속 클릭 가능)

export default {
  name: 'ReferralTreeDialog',
  components: { SettlementMemberSearchDialog, SettlementCenterSearchDialog },
  props: {
    admin: { type: Boolean, default: false }   // 스펙211: 관리자 추천 조직도(직급 아래 일캐시백 5% 표시)
  },
  data() {
    return {
      loading: false,
      error: '',
      // 3008: 시점 콤보. selectedPoint='CURRENT'(현재/라이브) 또는 'BEFORE|YYYY-MM-DD'/'AFTER|YYYY-MM-DD'(이력).
      //   콤보는 admin 전용. staff/customer 는 콤보 미표시 + 항상 '현재'(라이브 GRE_NODE).
      isAdminUser: false,
      selectedPoint: 'CURRENT',
      snapPoints: [],       // 3008: 전체 이력 스냅샷 목록 [{dt,'YYYY-MM-DD', t:'BEFORE'/'AFTER'}]
      selectedMonth: '',    // 3008: 월 선택기(YYYY-MM). 콤보는 이 달의 항목만 표시.
      // 3008: 노드 금액 표시 여부. '현재' 또는 '수당계산직후(AFTER)'만 표시, '수당계산직전(BEFORE)'은 숨김.
      shownAmounts: true,
      selectedUser: null,
      //조직도 팝업창 내 이름 조회 입력받기 프로젝트
      custName: '', custLoginId: '',
      searchOpen: false,
      centerOpen: false,               // 20007: 센터 검색 팝업 표시
      centerId: null, centerName: '',  // 20007: 센터 항목으로 선택된 센터
      side: 'B',
      zoom: 1,
      rootLabel: '',
      root: null,
      matchingGen: 0,   // 스펙214: A(1 row) 의 추천매칭 정산 대수(N). row 표시 개수 결정
      // 스펙209: 대(代) 스택. levels[k] = { copyNode(k>=1일 때 위쪽 복사행), children, title:(k+1)대, selectedChildId }
      levels: [],
      nodeW: 140, nodeH: 80, hGap: 18, vGap: 34, gutter: 46, pad: 22,
      layoutNodes: [],
      layoutEdges: [],
      floorBands: [],
      dividerX: null,
      svgW: 400,
      svgH: 300,
      rankColorList: [
        { name: '그린스타', hex: '00FF00' }, { name: '그린스타B', hex: '009C00' }, { name: '옐로스타', hex: 'FCCC44' },
        { name: '퍼플스타', hex: '7C4D9D' }, { name: '실버스타', hex: 'C1C0C5' },
        { name: '골드스타', hex: 'EBC04F' }, { name: '루비', hex: 'E31F21' },
        { name: '에메랄드', hex: '0A6544' }, { name: '다이아몬드', hex: '0A4DA4' },
        { name: '블루 다이아몬드', grad: true }, { name: '레드 다이아몬드', grad: true },
        { name: '크라운', hex: '031851' }, { name: '엠버서드', hex: '994B24' },
        { name: '임페리얼', hex: '55308F' }, { name: '퍼스트', hex: '076B7A' },
        { name: 'VIP', hex: '011F55' }, { name: 'VVIP', hex: '01215A' }
      ]
    };
  },
  computed: {
    todayStr() { const d = new Date(); const m = String(d.getMonth()+1).padStart(2,'0'); const dd = String(d.getDate()).padStart(2,'0'); return d.getFullYear()+'-'+m+'-'+dd; },
    // 3008: 현재 월(YYYY-MM). 월 선택기 기본값/최댓값.
    curMonth() { const d = new Date(); return d.getFullYear() + '-' + String(d.getMonth()+1).padStart(2,'0'); },
    // 3008: 선택한 월(selectedMonth)에 해당하는 스냅샷 항목만 + 마지막 '현재'.
    snapOptions() {
      const opts = [];
      const mon = this.selectedMonth || '';
      for (const p of this.snapPoints) {
        if (mon && String(p.dt).slice(0, 7) !== mon) continue;   // 해당 월 항목만
        opts.push({ value: p.t + '|' + p.dt, label: this.fmtDt(p.dt) + ' 수당계산' + (p.t === 'AFTER' ? '직후' : '직전') });
      }
      opts.push({ value: 'CURRENT', label: '현재' });
      return opts;
    },
    // 3008: 선택 시점 파싱. 'CURRENT' → {current:true}, 'BEFORE|dt'/'AFTER|dt' → {current:false, snapType, baseDate}
    selectedParsed() {
      if (!this.selectedPoint || this.selectedPoint === 'CURRENT') return { current: true };
      const i = this.selectedPoint.indexOf('|');
      if (i < 0) return { current: true };
      return { current: false, snapType: this.selectedPoint.slice(0, i), baseDate: this.selectedPoint.slice(i + 1) };
    },
    floorH() { return this.nodeH + this.vGap; },
    frameX() { return this.gutter; },
    frameY() { return this.pad; },
    frameW() { return this.svgW - this.gutter - this.pad; },
    frameH() { return this.svgH - this.frameY - this.pad; },
    roofPoints() {
      const x1 = this.frameX, x2 = this.frameX + this.frameW;
      const yBase = this.frameY, apex = this.frameX + this.frameW / 2;
      const yTop = Math.max(3, this.frameY - 15);
      return x1 + ',' + yBase + ' ' + apex + ',' + yTop + ' ' + x2 + ',' + yBase;
    }
  },
  watch: {
    // 라디오 변경 시 1대만 남기고(A의 좌/우 필터) 재구성
    side() { if (this.root) { this.levels = this.levels.slice(0, 1); if (this.levels[0]) this.levels[0].selectedChildId = null; this.buildLayout(); } },
    // 3008: 월 변경 시, 선택 시점을 '현재'로 되돌린다(다른 달 항목이 선택에 남지 않도록).
    selectedMonth() { this.selectedPoint = 'CURRENT'; }
  },
  created() {
    // 20007: 초기 진입 - role 무관 센터명/이름 에디트 비우기(비활성), 검색·비우기 버튼 활성. 비율 100%, 좌/우측 체크. 자동 조회 없음.
    //조직도 팝업창 내 이름 조회 입력받기 프로젝트
    this.selectedUser = null;
    this.centerId = null; this.centerName = '';
    this.searchOpen = false; this.centerOpen = false;
    this.side = 'B';
    this.zoom = 1;
    // 스펙211: 관리자 화면은 직급 아래 5% 줄이 추가되므로 네모를 세로로 키움
    if (this.admin) this.nodeH = 92;   // 스펙24003: 가입일/첫구매일/최근재구매일 + 관리자 금액 줄 높이 확대
    // 3008: 시점 콤보는 admin 전용. admin 이면 목록 로드(기본=최신 수당계산직후), 그 외는 항상 '현재'(라이브 GRE_NODE).
    this.isAdminUser = isAdmin();
    if (this.isAdminUser) this.loadSnapPoints();
    this.loadRankColors();
  },
  methods: {
    close() { this.$emit('close'); },
    onUserSelect(sel) {
      this.searchOpen = false;
      if (!sel || !sel.loginId) return;
      //조직도 팝업창 내 이름 조회 입력받기 프로젝트
      this.custName = sel.name || ''; this.custLoginId = sel.loginId;
      this.error = '';
    },
    // 20007: 센터 항목 센터 검색 팝업 선택 완료 → 센터명 에디트에 표시.
    onCenterSelect(sel) {
      this.centerOpen = false;
      if (!sel) return;
      this.centerId = sel.id != null ? sel.id : null;
      this.centerName = sel.centerName || sel.name || '';
      this.error = '';
    },
    // 20007: 비우기 버튼
    clearCenter() { this.centerId = null; this.centerName = ''; },
    //조직도 팝업창 내 이름 조회 입력받기 프로젝트
    clearMember() { this.custName = ''; this.custLoginId = ''; },
    async loadRankColors() {
      try {
        const res = await api.refList('POS_COLOR');
        const rows = (res && res.data) || [];
        if (rows.length) {
          this.rankColorList = rows.map(r => {
            const val = (r.val || '').trim();
            return val.indexOf(',') >= 0 ? { name: r.name, grad: true } : { name: r.name, hex: val };
          });
        }
      } catch (e) { /* 폴백: 하드코딩 유지 */ }
    },
    rankInfo(name) {
      return this.rankColorList.find(r => r.name === (name || '').trim()) || null;
    },
    displayRank(name) {
      return (name || '').trim() === '그린스타B' ? '그린스타' : name;
    },
    fmt(v) { return (Number(v) || 0).toLocaleString(); },
    nodeFill(n) {
      if (!n.active || Number(n.sales || 0) === 0) return '#ffffff';
      const r = this.rankInfo(n.rankName);
      if (!r) return '#ffffff';
      if (r.grad) return 'url(#rtGradDia)';
      return '#' + r.hex;
    },
    nodeStroke(n) {
      if (!n.active || Number(n.sales || 0) === 0) return '#b6c1d6';
      return '#33405c';
    },
    nodeText(n) {
      const fill = this.nodeFill(n);
      if (fill === '#ffffff') return '#1f2a44';
      if (fill.indexOf('url(') === 0) return '#ffffff';
      const hex = fill.slice(1);
      const r = parseInt(hex.slice(0, 2), 16), g = parseInt(hex.slice(2, 4), 16), b = parseInt(hex.slice(4, 6), 16);
      const lum = (0.299 * r + 0.587 * g + 0.114 * b);
      return lum > 150 ? '#1f2a44' : '#ffffff';
    },
    zoomIn() { this.zoom = Math.min(1, Math.round((this.zoom + 0.1) * 10) / 10); },
    zoomOut() { this.zoom = Math.max(0.1, Math.round((this.zoom - 0.1) * 10) / 10); },
    // 3008: 배치일 문자열 'YYYY-MM-DD' → 'YYYY년-MM월-DD일'
    fmtDt(dt) {
      const p = String(dt || '').split('-');
      return p.length < 3 ? String(dt || '') : (p[0] + '년-' + p[1] + '월-' + p[2] + '일');
    },
    // 3008: 시점 콤보 목록 로드. 전체 스냅샷을 보관하고, 콤보 표시는 선택 월(selectedMonth)로 필터. 진입 기본=현재.
    async loadSnapPoints() {
      try {
        const res = await api.histSnapshotPoints();
        const pts = (res && res.data) ? res.data : [];
        const list = [];
        for (const p of pts) {
          const dt = String(p.dt || '').slice(0, 10);
          const t = String(p.snapType || p.type || '').toUpperCase();
          if (!dt || (t !== 'BEFORE' && t !== 'AFTER')) continue;
          list.push({ dt: dt, t: t });
        }
        this.snapPoints = list;
      } catch (e) {
        this.snapPoints = [];
      }
      this.selectedMonth = this.curMonth;   // 월 선택기 기본 = 현재 월
      this.selectedPoint = 'CURRENT';        // 진입 기본 = 현재(라이브 GRE_NODE)
    },

    //조직도 팝업창 내 이름 조회 입력받기 프로젝트
    doSearch() {
      const id = String(this.custLoginId || '').trim();
      const name = String(this.custName || '').trim();
      if (!id && !name) { this.error = '이름을 입력하거나 검색 버튼으로 회원을 선택하세요.'; this.layoutNodes = []; return; }
      this.fetch(id, name);
    },

    //조직도 팝업창 내 이름 조회 입력받기 프로젝트
    async fetch(loginId, custName) {
      this.loading = true; this.error = '';
      try {
        // 3008: 선택 시점(현재/수당계산직전·직후)에 따라 조회.
        const sel = this.selectedParsed;
        // 3008: 금액 표시 여부 확정 - 현재/수당계산직후만 표시(수당계산직전은 숨김).
        this.shownAmounts = sel.current || sel.snapType === 'AFTER';
        const res = sel.current

          //조직도 팝업창 내 이름 조회 입력받기 프로젝트
          ? await api.referralTree({ targetLoginId: loginId, custName: custName })
          : await api.referralTreeHist({ targetLoginId: loginId, custName: custName, baseDate: sel.baseDate, snapType: sel.snapType });

        const d = res.data;
        if (!d || !d.root) { this.error = '추천 조직도 정보를 찾을 수 없습니다.'; this.root = null; this.layoutNodes = []; return; }
        this.root = d.root;
        this.matchingGen = Number(d.root.matchingGen || 0);   // 스펙214: A 의 추천매칭 정산 대수
        // 1대 = A 의 직접 피추천인
        this.levels = [{ copyNode: null, children: d.children || [], title: '1대', selectedChildId: null }];
        this.rootLabel = d.root.name + ' (' + d.root.loginId + ')';
        this.buildLayout();
        this.zoom = 1;
      } catch (e) {
        this.error = e.message || '조회 중 오류가 발생했습니다.';
        this.root = null; this.layoutNodes = [];
      } finally {
        this.loading = false;
      }
    },
    // 대(代) 네모 클릭 → 다음 대 펼침. n.level = 클릭 네모가 속한 대의 인덱스(k), 세대수 = k+1대.
    async onNodeClick(n) {
      if (!n.clickable || n.kind !== 'children') return;
      const k = n.level;
      if ((k + 1) >= MAX_GEN) return;   // 5대는 onclick 없음
      // k대까지만 유지, 그 아래 제거
      this.levels = this.levels.slice(0, k + 1);
      this.levels[k].selectedChildId = n.rawId;
      const clicked = (this.levels[k].children || []).find(c => c.id === n.rawId);
      try {
        const sel = this.selectedParsed;
        const res = sel.current
          ? await api.referralChildren(n.rawId)
          : await api.referralChildrenHist(n.rawId, sel.baseDate, sel.snapType);
        const children = (res && res.data) || [];
        this.levels.push({ copyNode: clicked, children: children, title: (k + 2) + '대', selectedChildId: null });
        this.buildLayout();
      } catch (e) {
        this.error = e.message || '다음 대 조회 중 오류가 발생했습니다.';
        this.buildLayout();
      }
    },
    edge(px, py, cx, cy) {
      const midY = (py + cy) / 2;
      return { d: 'M' + px + ',' + py + ' V' + midY + ' H' + cx + ' V' + cy };
    },
    // 스펙210: 복사행 없이 각 대(代)를 한 행에 표시. 모든 행 중앙 정렬, 자식행은 L=왼쪽/R=오른쪽 분리.
    buildLayout() {
      if (!this.root) { this.layoutNodes = []; this.layoutEdges = []; this.floorBands = []; this.dividerX = null; return; }
      const stepX = this.nodeW + this.hGap;
      const halfGap = this.hGap;
      const originX = this.gutter + this.pad;
      const originY = this.pad + 18;
      const fh = this.floorH;

      // 1) 표시 행(rows) 구성 : 1 row = A, 이후 각 대(代)를 한 행씩 (복사행 없음)
      const rows = [];
      rows.push({ kind: 'root', label: '', level: -1 });                 // 1 row : A (라벨 없음)
      this.levels.forEach((lv, k) => {
        rows.push({ kind: 'children', label: lv.title, level: k, children: lv.children, selectedChildId: lv.selectedChildId });
      });

      // 2) 각 행의 로컬 x 배치(중앙=0)
      const placedRows = rows.map((row, ri) => {
        const y = originY + ri * fh;
        if (row.kind === 'root') {
          return { row, ri, y, placed: [{ node: this.root, x: -this.nodeW / 2, leg: '', clickable: false, selected: false }] };
        }
        // children : 좌/우 분리 (1대는 라디오 필터 적용)
        let all = row.children || [];
        if (row.level === 0) {
          if (this.side === 'L') all = all.filter(c => (c.leg || '') !== 'R');
          else if (this.side === 'R') all = all.filter(c => (c.leg || '') === 'R');
        }
        const leftK = all.filter(c => (c.leg || '') !== 'R');   // L + 미설정 → 좌
        const rightK = all.filter(c => (c.leg || '') === 'R');
        const nL = leftK.length;
        const gen = row.level + 1;                 // 세대수
        const clickable = (gen < MAX_GEN) && canViewAll();   // 스펙220: customer 는 네모 클릭 불가(staff/admin 만)
        const placed = [];
        leftK.forEach((c, i) => placed.push({ node: c, x: -halfGap - this.nodeW - (nL - 1 - i) * stepX, leg: c.leg || '', clickable, selected: row.selectedChildId === c.id }));
        rightK.forEach((c, j) => placed.push({ node: c, x: halfGap + j * stepX, leg: c.leg || '', clickable, selected: row.selectedChildId === c.id }));
        return { row, ri, y, placed };
      });

      // 3) 전역 shift(음수 x 방지)
      let minX = 0;
      placedRows.forEach(pr => pr.placed.forEach(p => { if (p.x < minX) minX = p.x; }));
      const shift = originX - minX;
      const centerX = shift;   // 로컬 0 → 화면 x

      // 4) 노드/밴드 생성
      const nodes = [];
      const bands = [];
      placedRows.forEach((pr) => {
        bands.push({ y: pr.y - 6, label: pr.row.label, idx: pr.ri, key: 'b' + pr.ri });
        pr.placed.forEach(p => {
          nodes.push({
            key: (pr.row.kind) + '-' + pr.ri + '-' + p.node.id,
            rawId: p.node.id, x: p.x + shift, y: pr.y,
            name: p.node.name, loginId: p.node.loginId, rankName: p.node.rankName,
            joinDt: p.node.joinDt || '',   // 23001: 네모칸 직급 아래 가입일(빌드 시 필드 누락 수정)
            firstBuyDt: p.node.firstBuyDt || '',            // 스펙24003: 첫구매일
            lastRepurchaseDt: p.node.lastRepurchaseDt || '',// 스펙24003: 최근 재구매일(없으면 미표시)
            active: !!p.node.active, sales: Number(p.node.sales || 0), leg: p.leg,
            // 스펙214(개정): 관리자 금액. 1 row(A)=자신의 추천매칭 캐시백 그대로(항상 표시), 그 외=자신의 팀캐시백×0.05.
            //   대(代) 표시 조건: 대 번호(k) <= A 의 추천매칭 정산 대수(N). ri>=1 이면 ri 가 곧 k대.
            adminAmount: pr.row.kind === 'root' ? Number(p.node.matchingCb || 0) : Math.floor(Number(p.node.dailyCb || 0) * 0.05),
            adminPrefix: pr.row.kind === 'root' ? '합계: ' : '',   // 스펙214: 1 row 는 "합계: " 접두
            showAdmin: pr.row.kind === 'root' ? true : (pr.ri <= this.matchingGen),
            clickable: p.clickable, selected: p.selected, level: pr.row.level, kind: pr.row.kind
          });
        });
      });

      // 5) 간선 : 각 자식행 노드 ← 부모(1대는 A중앙, 그 외는 바로 위 행에서 클릭된 노드)
      const edges = [];
      placedRows.forEach((pr) => {
        if (pr.row.kind !== 'children') return;
        const above = placedRows[pr.ri - 1];
        let parentCx = centerX;
        const parentBottomY = pr.y - fh + this.nodeH;
        if (pr.row.level > 0 && above) {
          const sel = above.placed.find(p => p.selected);
          if (sel) parentCx = sel.x + shift + this.nodeW / 2;
        }
        pr.placed.forEach(p => edges.push(this.edge(parentCx, parentBottomY, p.x + shift + this.nodeW / 2, pr.y)));
      });

      // 6) 캔버스 크기 (적색 기준선은 스펙209 로 삭제)
      const maxX = nodes.reduce((m, nd) => Math.max(m, nd.x + this.nodeW), originX + this.nodeW);
      this.svgW = maxX + this.pad;
      this.svgH = originY + rows.length * fh + this.pad;
      this.floorBands = bands;
      this.dividerX = null;
      this.layoutNodes = nodes;
      this.layoutEdges = edges;
    }
  }
};
</script>

<style scoped>
.pt-mask {
  position: fixed; inset: 0; background: rgba(15, 22, 40, 0.55);
  display: flex; align-items: center; justify-content: center; z-index: 1000;
}
/* 스펙209: 팝업 가로를 화면 끝까지 넓게 */
.pt-modal {
  background: #fff; border-radius: 12px; width: 99vw; max-width: none; max-height: 92vh;
  display: flex; flex-direction: column; box-shadow: 0 18px 60px rgba(0,0,0,0.35);
}
.pt-head {
  display: flex; align-items: center; justify-content: space-between;
  padding: 13px 20px; border-bottom: 1px solid #e6ebf3;
}
.pt-head h4 { margin: 0; font-size: 16px; color: #1f2a44; }
.pt-head-right { display: flex; align-items: center; gap: 14px; }
.pt-legend { font-size: 12px; color: #55617a; display: inline-flex; align-items: center; gap: 5px; }
.pt-legend .dot { width: 11px; height: 11px; border-radius: 3px; display: inline-block; border: 1px solid #cdd6e6; }
.dot.inactive { background: #ffffff; }
.pt-x {
  border: 1px solid #cfd6e6; background: #f4f6fa; border-radius: 6px;
  padding: 5px 12px; cursor: pointer; font-size: 13px; color: #33405c;
}
.pt-x:hover { background: #e9eef7; }

.pt-toolbar {
  display: flex; align-items: center; gap: 8px; flex-wrap: wrap;
  padding: 10px 20px; background: #f7f9fc; border-bottom: 1px solid #eef2f8;
}
.pt-toolbar label { font-size: 13px; color: #33405c; font-weight: 600; }
.pt-toolbar .pt-user { font-size: 13px; color: #1f2a44; font-weight: 600; min-width: 140px;
  padding: 4px 8px; background: #eef3fb; border: 1px solid #d7e0ef; border-radius: 6px; }
.pt-toolbar button.primary {
  height: 30px; border: none; background: #4d8bff; color: #fff; border-radius: 6px;
  padding: 0 14px; cursor: pointer; font-size: 13px;
}
.pt-toolbar button.primary:hover { background: #3f79e8; }
/* 20007: 센터/이름 검색조건 에디트(비활성, 가로 축소) + 비우기 버튼 */
.pt-toolbar input.cond {
  height: 30px; border: 1px solid #cfd6e6; border-radius: 6px; padding: 0 10px;
  font-size: 13px; width: 110px; background: #f2f4f7; color: #667085;
}
/* 조직도 팝업창 내 이름 조회 입력받기 프로젝트 */
.pt-toolbar input.cond-edit {
  background: #fff;
  color: #1f2a44;
}
.pt-toolbar button.ghost {
  height: 30px; border: 1px solid #c0c6d0; background: #f2f4f7; color: #444;
  border-radius: 6px; padding: 0 12px; cursor: pointer; font-size: 13px;
}
.pt-toolbar button.ghost:hover { background: #e9edf3; }
.pt-radios { display: inline-flex; gap: 12px; align-items: center; }
.pt-radios .rd { font-size: 13px; color: #33405c; font-weight: 500; display: inline-flex; align-items: center; gap: 4px; }
.pt-sep { width: 1px; height: 22px; background: #dbe2ee; margin: 0 4px; }
.pt-zoom-label { font-size: 12px; color: #55617a; }
.pt-zoom {
  width: 30px; height: 30px; border: 1px solid #cfd6e6; background: #fff; border-radius: 6px;
  cursor: pointer; font-size: 16px; line-height: 1; color: #33405c;
}
.pt-zoom:hover:not(:disabled) { background: #eef3fb; }
.pt-zoom:disabled { opacity: 0.4; cursor: not-allowed; }
.pt-zoom-val { font-size: 12px; color: #33405c; min-width: 42px; text-align: center; font-weight: 600; }
.pt-basedate { height: 26px; border: 1px solid #cfd6e6; border-radius: 6px; padding: 0 6px; font-size: 12px; color: #33405c; }
.pt-snapsel { height: 26px; border: 1px solid #cfd6e6; border-radius: 6px; padding: 0 6px; font-size: 12px; color: #33405c; background: #fff; max-width: 240px; }
.pt-summary-inline { font-size: 12.5px; color: #55617a; margin-left: auto; }

.pt-body { overflow: auto; padding: 12px; flex: 1; }
.pt-msg { padding: 40px; text-align: center; color: #6b7691; font-size: 14px; }
.pt-msg.err { color: #c0392b; }
.pt-canvas { overflow: auto; }

.pt-roof { fill: #37507d; stroke: #2a3c5e; stroke-width: 1; }
.pt-frame { fill: #fbfcfe; stroke: #37507d; stroke-width: 2; }
.pt-band.odd { fill: #f2f5fb; }
.pt-band.even { fill: #e9eef8; }
.pt-floor-line { stroke: #d3dcec; stroke-width: 1; }
.pt-floor-label { fill: #6b7691; font-size: 11px; font-weight: 700; }
.pt-edge { fill: none; stroke: #9fb0cc; stroke-width: 1.4; }
.rt-divider { stroke: #c0392b; stroke-dasharray: 5 4; stroke-width: 1.3; opacity: 0.55; }

.pt-node { stroke-width: 1.4; }
.clickable { cursor: pointer; }
.clickable .pt-node:hover { filter: brightness(0.94); }
.pt-node-name { font-size: 11px; font-weight: 700; }
.pt-node-sub { font-size: 9.5px; }
.pt-node-rank { font-size: 9.5px; font-weight: 600; }
.pt-node-join { font-size: 9.5px; opacity: 0.9; }   /* 스펙24003: 가입일/첫구매일/최근재구매일 9.5px */
.pt-node-cb5 { font-size: 9px; font-weight: 700; }
.pt-leg-badge { font-size: 9px; font-weight: 700; }

.pt-colorbar {
  display: flex; align-items: center; gap: 10px 14px; flex-wrap: wrap;
  padding: 8px 20px; background: #fff; border-bottom: 1px solid #eef2f8;
}
.pt-colorbar-title { font-size: 12px; font-weight: 700; color: #33405c; }
.pt-color-item { font-size: 11px; color: #55617a; display: inline-flex; align-items: center; gap: 4px; }
.pt-color-item .sw { width: 13px; height: 13px; border-radius: 3px; display: inline-block; border: 1px solid #cdd6e6; }
</style>
